import React from "react";
import PropTypes from "prop-types";
import utils from "../../services/utils";

/**
 * Компонент для отображения иконки валюты с названием валюты
 */
class CurrencyInfo extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        let classNoUrl = 'currency-info__img--url-false';
        if (this.props.currency.linkToIcon) {
            classNoUrl = '';
        }

        return (
            <span className={"currency-info"}>
                <span className={`currency-info__img ${classNoUrl}`}
                    style={{ backgroundImage: "url(" + this.props.currency.linkToIcon + ")" }} />
                {this.props.showShortName &&
                    <span className={"currency-info__text"}>{utils.getDisplayOrRealName(this.props.currency)}</span>
                }
            </span>
        )
    }

    static propsTypes = {
        currency: PropTypes.object.isRequired,
        showShortName: PropTypes.bool,
    }

    static defaultProps = {
        showShortName: true
    };
}

export default CurrencyInfo